export function PlayStoreButton({ className }: { className?: string }) {
  return (
    <a
      href="https://play.google.com/store/apps/details?id=com.gymflow.member"
      target="_blank"
      rel="noreferrer"
      className={className}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="121"
        height="46"
        viewBox="0 0 121 46"
        fill="none"
      >
        <rect
          x="0.5"
          y="0.5"
          width="119.255"
          height="45"
          rx="8.5"
          fill="white"
          stroke="#090909"
        />
        <g filter="url(#filter0_ii_2733_2483)">
          <path
            d="M12.8013 12.1418C12.5462 12.4129 12.3954 12.8335 12.3954 13.3782V32.8403C12.3954 33.3859 12.5462 33.8057 12.8013 34.0767L12.8662 34.1401L23.7261 23.2377V23.1093V22.9808L12.8662 12.0776L12.8013 12.1418Z"
            fill="url(#paint0_linear_2733_2483)"
          />
          <path
            d="M27.3453 26.8729L23.7259 23.2376V23.1091V22.9807L27.3462 19.3463L27.4277 19.3929L31.7168 21.8393C32.9414 22.538 32.9414 23.6811 31.7168 24.3807L27.4277 26.8271L27.3453 26.8729Z"
            fill="url(#paint1_linear_2733_2483)"
          />
          <g filter="url(#filter1_i_2733_2483)">
            <path
              d="M27.4278 26.8261L23.7252 23.109L12.8012 34.0764C13.2045 34.5059 13.8715 34.5587 14.6228 34.131L27.4278 26.8261Z"
              fill="url(#paint2_linear_2733_2483)"
            />
          </g>
          <path
            d="M27.4278 19.3921L14.6228 12.0881C13.8715 11.6595 13.2045 11.7132 12.8012 12.1427L23.726 23.1101L27.4278 19.3921Z"
            fill="url(#paint3_linear_2733_2483)"
          />
        </g>
        <path
          d="M60.1791 20.0019C58.2319 20.0019 56.6448 21.4823 56.6448 23.5212C56.6448 25.5477 58.2319 27.0405 60.1791 27.0405C62.1272 27.0405 63.7143 25.5477 63.7143 23.5212C63.7134 21.4823 62.1264 20.0019 60.1791 20.0019ZM60.1791 25.6553C59.112 25.6553 58.1922 24.7756 58.1922 23.522C58.1922 22.2551 59.1128 21.3888 60.1791 21.3888C61.2463 21.3888 62.1661 22.2551 62.1661 23.522C62.1661 24.7748 61.2463 25.6553 60.1791 25.6553ZM52.4681 20.0019C50.5209 20.0019 48.9338 21.4823 48.9338 23.5212C48.9338 25.5477 50.5209 27.0405 52.4681 27.0405C54.4161 27.0405 56.0032 25.5477 56.0032 23.5212C56.0032 21.4823 54.4161 20.0019 52.4681 20.0019ZM52.4681 25.6553C51.4009 25.6553 50.4811 24.7756 50.4811 23.522C50.4811 22.2551 51.4017 21.3888 52.4681 21.3888C53.5352 21.3888 54.455 22.2551 54.455 23.522C54.4559 24.7748 53.5352 25.6553 52.4681 25.6553ZM43.2966 21.0826V22.5754H46.8715C46.7647 23.4153 46.4848 24.0284 46.0576 24.4546C45.5377 24.9742 44.7239 25.5477 43.2966 25.5477C41.096 25.5477 39.3757 23.7744 39.3757 21.5749C39.3757 19.3755 41.096 17.6022 43.2966 17.6022C44.4838 17.6022 45.3506 18.0689 45.9906 18.6688L47.0445 17.6155C46.1504 16.7623 44.964 16.1094 43.2966 16.1094C40.2822 16.1094 37.748 18.5621 37.748 21.5749C37.748 24.5878 40.2822 27.0405 43.2966 27.0405C44.9234 27.0405 46.1512 26.5067 47.1107 25.5071C48.0976 24.5208 48.4047 23.1339 48.4047 22.0143C48.4047 21.6684 48.3782 21.3482 48.3244 21.0818L43.2966 21.0826ZM80.8071 22.2419C80.514 21.4558 79.6199 20.0019 77.7927 20.0019C75.9788 20.0019 74.4712 21.4285 74.4712 23.5212C74.4712 25.4939 75.9655 27.0405 77.9657 27.0405C79.5793 27.0405 80.5132 26.0541 80.9006 25.4807L79.7002 24.6805C79.3003 25.2672 78.7531 25.6536 77.9657 25.6536C77.1792 25.6536 76.6187 25.2936 76.2586 24.587L80.9669 22.6407L80.8071 22.2419ZM76.0053 23.4153C75.9655 22.0549 77.0592 21.3623 77.8465 21.3623C78.46 21.3623 78.9799 21.6693 79.1538 22.1087L76.0053 23.4153ZM72.1779 26.8278H73.7244V16.4835H72.1779V26.8278ZM69.6429 20.7888H69.5899C69.243 20.3751 68.5757 20.0019 67.7362 20.0019C65.9753 20.0019 64.3617 21.5485 64.3617 23.5352C64.3617 25.508 65.9753 27.0413 67.7362 27.0413C68.5765 27.0413 69.243 26.6681 69.5899 26.2419H69.6429V26.7484C69.6429 28.0947 68.9226 28.8146 67.7627 28.8146C66.8156 28.8146 66.2286 28.1352 65.9885 27.5618L64.6415 28.122C65.0281 29.0545 66.0547 30.2014 67.7627 30.2014C69.5766 30.2014 71.1107 29.1348 71.1107 26.5349V20.2162H69.6437L69.6429 20.7888ZM67.8695 25.6553C66.8023 25.6553 65.909 24.7616 65.909 23.5352C65.909 22.2949 66.8023 21.3888 67.8695 21.3888C68.9226 21.3888 69.7496 22.2949 69.7496 23.5352C69.7496 24.7616 68.9226 25.6553 67.8695 25.6553ZM88.0545 16.4835H84.353V26.8278H85.897V22.9088H88.0537C89.7658 22.9088 91.4497 21.6701 91.4497 19.6966C91.4497 17.723 89.7666 16.4835 88.0545 16.4835ZM88.0942 21.469H85.897V17.9233H88.0942C89.2492 17.9233 89.9049 18.879 89.9049 19.6966C89.9049 20.4976 89.2492 21.469 88.0942 21.469ZM97.6416 19.9837C96.5231 19.9837 95.3649 20.4761 94.8855 21.5675L96.2565 22.1393C96.5496 21.5675 97.096 21.3805 97.6681 21.3805C98.467 21.3805 99.2792 21.8596 99.2924 22.7111V22.8178C99.0126 22.6581 98.4132 22.419 97.6813 22.419C96.2035 22.419 94.6984 23.2307 94.6984 24.7475C94.6984 26.1319 95.9104 27.0231 97.2682 27.0231C98.3064 27.0231 98.8793 26.5572 99.2386 26.0111H99.2916V26.8096H100.783V22.8435C100.784 21.0081 99.4116 19.9837 97.6416 19.9837ZM97.4545 25.6528C96.9495 25.6528 96.2433 25.3996 96.2433 24.774C96.2433 23.9755 97.1225 23.6693 97.8817 23.6693C98.5597 23.6693 98.8801 23.8158 99.2924 24.0152C99.1724 24.9742 98.347 25.6528 97.4545 25.6528ZM106.216 20.2096L104.445 24.6945H104.392L102.554 20.2096H100.89L103.646 26.4778L102.075 29.9648H103.686L107.934 20.2096H106.216ZM92.3025 26.8278H93.8465V16.4835H92.3025V26.8278Z"
          fill="#090909"
        />
        <defs>
          <filter
            id="filter0_ii_2733_2483"
            x="12.3954"
            y="11.7924"
            width="20.2398"
            height="22.634"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="-0.795" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_2733_2483"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.795" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_innerShadow_2733_2483"
              result="effect2_innerShadow_2733_2483"
            />
          </filter>
          <filter
            id="filter1_i_2733_2483"
            x="12.8012"
            y="23.109"
            width="14.6266"
            height="11.3174"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="-0.795" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_2733_2483"
            />
          </filter>
          <linearGradient
            id="paint0_linear_2733_2483"
            x1="22.7634"
            y1="13.1723"
            x2="7.9954"
            y2="27.8829"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00A0FF" />
            <stop offset="0.0066" stopColor="#00A1FF" />
            <stop offset="0.2601" stopColor="#00BEFF" />
            <stop offset="0.5122" stopColor="#00D2FF" />
            <stop offset="0.7604" stopColor="#00DFFF" />
            <stop offset="1" stopColor="#00E3FF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2733_2483"
            x1="33.3108"
            y1="23.1091"
            x2="12.1012"
            y2="23.1091"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFE000" />
            <stop offset="0.4087" stopColor="#FFBD00" />
            <stop offset="0.7754" stopColor="#FFA500" />
            <stop offset="1" stopColor="#FF9C00" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2733_2483"
            x1="25.417"
            y1="25.1276"
            x2="5.38972"
            y2="45.0771"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF3A44" />
            <stop offset="1" stopColor="#C31162" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2733_2483"
            x1="10.05"
            y1="5.66393"
            x2="18.9928"
            y2="14.5719"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#32A071" />
            <stop offset="0.0685" stopColor="#2DA771" />
            <stop offset="0.4762" stopColor="#15CF74" />
            <stop offset="0.8009" stopColor="#06E775" />
            <stop offset="1" stopColor="#00F076" />
          </linearGradient>
        </defs>
      </svg>
    </a>
  );
}
